export default {
    model: {
        email: {
            label: "E-mail",
            placeholder: "Jméno nebo e-mail delegáta",
            notFound: "Uživatelé nenalezeny"
        },
        start_on: {
            label: "Datum zahájení",
            placeholder: "Datum zahájení delegování"
        },
        end_on: {
            label: "Datum ukončení",
            placeholder: "Volitelný"
        },
        accept: {
            tip: "Delegováním své schvalovací odpovědnosti potvrzujete, že přebíráte odpovědnost za veškeré objednávky schválené vaším delegátem.",
            label: "Přijímám"
        }
    },
    buttons: {
        submit: {
            cta: "Potvrdit",
            processing: "Ukládání"
        },
        close: {
            cta: "Zrušit"
        }
    },
    saved: "Uloženo"
}